import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";


export class AddMagiisAccessCarrierProfile extends IRequestCommand<
  IAddMagiisAccessCarrierProfileResponse,
  ErrorDetails,
  IAddMagiisAccessCarrierProfileParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;

  override setParameters(parameters: IAddMagiisAccessCarrierProfileParameters) {
    this._commandBody = parameters;
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`carrierprofile`);
    this.composeUrl();
  }
}

export interface IAddMagiisAccessCarrierProfileParameters extends ICommandParameters{
  carrierAccountId: string;
  name: string;
  description?: string;
  status: string;
  creationUserId: string;
  updateUserId: string;
}

export interface IAddMagiisAccessCarrierProfileResponse extends ICommandResponse{

}
